/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

// Product tile IDs used to identify Hotels and SNAP tiles from CMS data
export const TILE_PRODUCT_IDS = {
  HOTELS: 'hotels',
  SNAP: 'snap',
} as const;

const createSearchPageUrls = (product: string, newSearchSubdomain: string) =>
  ({
    new: {
      prod: `https://${newSearchSubdomain}.airasia.com/Search`,
      stg: `https://${newSearchSubdomain}.stgairasia.com/Search`,
      dev: `https://${newSearchSubdomain}.devairasia.com/Search`,
    },
    old: {
      prod: `https://www.airasia.com/${product}/en/gb`,
      stg: `https://www.stgairasia.com/${product}/en/gb`,
      dev: `https://www.devairasia.com/${product}/en/gb`,
    },
  }) as const;

// Environment-aware redirect URLs for Hotels tile
export const HOTEL_SEARCH_PAGE_URLS = createSearchPageUrls('hotels', 'hotels');

// Environment-aware redirect URLs for SNAP tile
export const SNAP_SEARCH_PAGE_URLS = createSearchPageUrls('snap', 'snp');

// Combined map keyed by productId for easy lookup
export const TILE_REDIRECT_URL_MAP: Record<
  string,
  {
    new: { prod: string; stg: string; dev: string };
    old: { prod: string; stg: string; dev: string };
  }
> = {
  [TILE_PRODUCT_IDS.HOTELS]: HOTEL_SEARCH_PAGE_URLS,
  [TILE_PRODUCT_IDS.SNAP]: SNAP_SEARCH_PAGE_URLS,
};
